import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { Seller } from '@40seas/entities/sellers';
import {
    BaseEntity,
    BusinessType,
    Fee,
    FeeSchema,
    PaymentMethodType,
    PaymentTerm,
    PaymentTermSchema,
    WithBaseEntitySchema,
} from '@40seas/models';
import { z } from 'zod';
import { FeeDefinitionCardOptions, FeeDefinitionCardOptionsSchema } from './fee-definition-card-options.entity';
import { FeeDefinitionDirectDebitOptions, FeeDefinitionDirectDebitOptionsSchema } from './fee-definition-direct-debit-options.entity';
import { FeeDefinitionWireOptions, FeeDefinitionWireOptionsSchema } from './fee-definition-wire-options.entity';
import { FeeDefinitionStatus } from './fee-definition.status.enum';
import { FeeDefinitionType } from './fee-definition.type.enum';

export type PaymentMethodOptions = {
    [key in PaymentMethodType]?: FeeDefinitionWireOptions | FeeDefinitionDirectDebitOptions | FeeDefinitionCardOptions;
};

export const FeeDefinitionSchema = WithBaseEntitySchema(
    z.object({
        volumeMin: z.number().nullish(),
        volumeMax: z.number().nullish(),
        amountMin: z.number().nullish(),
        amountMax: z.number().nullish(),
        paymentTerm: PaymentTermSchema.nullish(),
        paymentFee: FeeSchema.nullish(),
        adjustment: FeeSchema.nullish(),
        paymentMethods: z.array(EnumSchema(PaymentMethodType)).nullish(),
        status: EnumSchema(FeeDefinitionStatus),
        type: EnumSchema(FeeDefinitionType),
        businessType: EnumSchema(BusinessType),
        paymentMethodOptions: z
            .record(
                z.string(),
                z.union([FeeDefinitionWireOptionsSchema, FeeDefinitionDirectDebitOptionsSchema, FeeDefinitionCardOptionsSchema]),
            )
            .nullish(),
    }),
).strict();

export class FeeDefinition extends FromSchema(FeeDefinitionSchema) implements BaseEntity {
    id: string;
    volumeMin?: number;
    volumeMax?: number;
    amountMin?: number;
    amountMax?: number;
    paymentMethods: PaymentMethodType[];
    paymentTerm?: PaymentTerm;
    type: FeeDefinitionType;
    paymentFee: Fee;
    adjustment?: Fee;
    buyerFee: Fee;
    supplierFee: Fee;
    status: FeeDefinitionStatus;
    businessType: BusinessType;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    seller?: string | Seller;
    tenantId: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
    paymentMethodOptions?: PaymentMethodOptions;
}

export class MultiTenantFeeDefinition extends FeeDefinition {}
